// extracted by mini-css-extract-plugin
export default {"price":"Price_price","big":"Price_big","old":"Price_old","priceFree":"Price_priceFree","realPrice":"Price_realPrice","formattedPrice":"Price_formattedPrice"};